import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M0,373.397333 L0,1760.064 L1706.66667,1760.064 L1706.66667,956.864 L1600,956.864 L1600,1559.424 L1294.4,1192.59733 L1212.37333,1260.864 L1539.41333,1653.39733 L167.253333,1653.39733 L494.293333,1260.864 L412.266667,1192.59733 L106.666667,1559.424 L106.666667,661.824 L853.333333,1352.704 L1343.89333,898.944 L1271.57333,820.544 L853.333333,1207.31733 L106.666667,516.437333 L106.666667,480.064 L1123.2,480.064 L1123.2,373.397333 L0,373.397333 Z M1383.95733,243.872 C1447.104,186.165333 1529.45067,156.512 1614.25067,160.352 C1699.584,164.192 1778.41067,200.992 1836.11733,264.032 C1893.824,327.072 1923.47733,408.885333 1919.63733,494.325333 C1915.904,579.658667 1879.104,658.485333 1815.95733,716.192 C1756.544,770.592 1680.384,800.032 1600.384,800.032 C1595.47733,800.032 1590.67733,799.925333 1585.77067,799.712 C1500.33067,795.872 1421.61067,759.072 1363.904,696.032 C1306.19733,632.992 1276.544,551.178667 1280.27733,465.738667 C1284.11733,380.405333 1320.91733,301.578667 1383.95733,243.872 Z M1599.744,266.698667 C1546.41067,266.698667 1495.63733,286.325333 1456.064,322.592 C1413.93067,361.098667 1389.39733,413.578667 1386.83733,470.538667 C1384.27733,527.498667 1404.11733,581.898667 1442.51733,624.032 C1481.024,666.058667 1533.61067,690.592 1590.57067,693.152 C1647.424,696.032 1701.93067,675.872 1743.95733,637.472 C1786.09067,598.965333 1810.624,546.378667 1813.07733,489.525333 C1815.63733,432.565333 1795.904,378.058667 1757.39733,336.032 C1718.99733,294.005333 1666.41067,269.472 1609.45067,266.912 C1606.25067,266.698667 1603.05067,266.698667 1599.744,266.698667 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconNextUnreadLine = /*#__PURE__*/function (_Component) {
  _inherits(IconNextUnreadLine, _Component);

  var _super = _createSuper(IconNextUnreadLine);

  function IconNextUnreadLine() {
    _classCallCheck(this, IconNextUnreadLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconNextUnreadLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconNextUnread",
        viewBox: "0 0 1920 1920",
        bidirectional: true
      }), _ref);
    }
  }]);

  IconNextUnreadLine.displayName = "IconNextUnreadLine";
  return IconNextUnreadLine;
}(Component);

IconNextUnreadLine.glyphName = 'next-unread';
IconNextUnreadLine.variant = 'Line';
IconNextUnreadLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconNextUnreadLine;
export { IconNextUnreadLine };